module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/fonts/glyphicons-halflings-regular.ttf
 ** module id = 756
 ** module chunks = 1
 **/